import React, {PureComponent} from 'react'
import injectSheet, {withTheme} from 'react-jss'
import flow from 'lodash/flow'
import cn from 'classnames'
import ArticleCard from './ArticleCard'
import ImageOrVideo from "../Widgets/ImageOrVideo"

class ArticleHeroFeatureCard extends PureComponent {

    render() {
      const { classes, theme, article, images, contentPosition, video, video_mobile, isMobile, ...rest} = this.props
      const featuredVideo = video_mobile && isMobile ? video_mobile : video
      let positionClass = contentPosition === 'Right' ? 'contentRight' : 'contentLeft'

      return (
        <div className={classes.container}>
          <ImageOrVideo 
            key={featuredVideo ? featuredVideo.id : "image"}
            className={cn(classes.imageWrapper,classes[positionClass])}
            imageClassName={classes.image}
            images={images}
            video={featuredVideo}
            link={article.link}
            paused={false}
            dataCy='heroImageContainer'
          />
          <div className={cn(classes.cardWrapper,classes[positionClass])} >
            <ArticleCard
              article={article}
              size='large'
              dividerSpacing='small'
              showArticleTime={true}
              image={null}
              className={classes}
              cardClassName={classes.card}
              fakeLink={true}
              clampSummary={3}
              hoverEffect={true}
              {...rest}
            >
            </ArticleCard>
          </div>
        </div>
      )        
    }
}

export default flow([
  injectSheet( theme => ({
    container: {
      position: 'relative',
      marginBottom: '-30px',
      [theme.breakpoint('tablet')]: {
        marginBottom: 0
      },
      '&:hover .hover': {
        textDecoration: 'none',
        transform: 'scale(1.03)',
        boxShadow: 'none'
      }
    },
    imageWrapper: {
      marginLeft: '-16px',
      [theme.breakpoint('tablet')]: {
        marginLeft: 0
      },
      [theme.breakpoint('laptop')]: {
        maxWidth: '90%'
      },
      [theme.breakpoint('desktop')]: {
        maxWidth: 1065
      }
    },
    cardWrapper: {
      position: 'relative',
      bottom: 32,
      padding: 0,
      maxWidth: '100%',
      marginRight: 32,
      minWidth: '33%',
      [theme.breakpoint('laptop')]: {
        position: 'absolute',
        maxWidth: '33%',
        margin: 0,
        bottom: 42
      }
    },
    cardContainer: {
      zIndex: theme.zIndex.card,
      width: '100%'
    },
    card: {
      borderRadius: 0,
      height: '100%',
      margin: 0
    },
    contentRight: {
      [theme.breakpoint('laptop')]: {
        marginLeft: 0,
        right: 0
      }
    },
    contentLeft: {
      [theme.breakpoint('laptop')]: {
        marginLeft: 'auto',
        left: 0
      }
    },
    summary: {
      color: theme.colors.subTitle
    }
  })),
  withTheme
])(ArticleHeroFeatureCard)





// WEBPACK FOOTER //
// ./src/components/Card/ArticleHeroFeatureCard.js